import { useCallback } from 'react'

/**
 * Custom hook for consistent error handling across components
 * Provides a standardized way to handle errors with logging and user feedback
 */
const useErrorHandler = (setErrorMessage: (message: string) => void) => {
  const handleError = useCallback(
    (context: string, e?: Error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.log(e)
      }

      const exceptionMessage = e?.message

      // Handle maintenance mode by redirecting
      if (exceptionMessage === 'maintenance') {
        window.location.href = `/service-unavailable?message=${exceptionMessage}`
        return
      }

      // Set user-friendly error message
      setErrorMessage(
        `${context} - ${exceptionMessage || 'no message provided'}`,
      )
    },
    [setErrorMessage],
  )

  const resetError = useCallback(() => {
    setErrorMessage('')
  }, [setErrorMessage])

  return { handleError, resetError }
}

export default useErrorHandler
